module.exports = __webpack_public_path__ + "img/f3_img.fd387c2.png";